import React from 'react';
import Icon from 'components/icon';
import Cookies from 'universal-cookie';
import { bool, string } from 'prop-types';

export default class Notification extends React.Component {
    constructor(props) {
        super(props);

        const { notificationId } = this.props;
        const cookies = new Cookies();

        this.state = { hideNotif: cookies.get(notificationId) === '1' };
        this.closeButtonHandler = this.closeButtonHandler.bind(this);
    }

    closeButtonHandler() {
        const { notificationId } = this.props;
        const cookies = new Cookies();
        cookies.set(notificationId, '1', { path: '/' });
        this.setState({ hideNotif: true });
    }

    messageTemplate(template) {
        switch (template) {
            case 'EDIT_COSTCODE':
                return (
                    <React.Fragment>
                        You can also add/edit a cost code for single line items by clicking &lsquo;edit&rsquo; &nbsp;
                        <Icon glyph="pencil" />
                        &nbsp; in the sections below.
                    </React.Fragment>
                );
            case 'SUBMIT_COSTCODE_SUCCESS':
                return (
                    <React.Fragment>
                        <Icon glyph="tick" />
                        &nbsp; Your Cost Code has been succesfully added to this document.
                    </React.Fragment>
                );
            case 'SUBMIT_COSTCODE_FAILED':
                return (
                    <React.Fragment>
                        <Icon glyph="cross" />
                        &nbsp; We are unable to add your Cost Code to this document.
                    </React.Fragment>
                );
            default:
                return '';
        }
    }

    render() {
        const { hideNotif } = this.state;
        const { template, message, showCloseButton, className } = this.props;

        if (!hideNotif) {
            return (
                <div className={`notif-container ${className}`}>
                    {showCloseButton &&
                        <div className="notif-control">
                            <button className="notif-close-btn" onClick={this.closeButtonHandler}>
                                <Icon glyph="cross" />
                            </button>
                        </div>
                    }
                    <div className="notif-message">
                        {template &&
                            this.messageTemplate(template)
                        }
                        {!template &&
                            message
                        }
                    </div>
                </div>
            );
        }

        return null;
    }
}

Notification.propTypes = {
    notificationId: string.isRequired,
    message: string,
    template: string,
    showCloseButton: bool,
    className: string
};

Notification.defaultProps = {
    message: undefined,
    template: undefined,
    showCloseButton: true,
    className: ''
};
